import React, { Fragment } from "react";

export default (
  <>
    <path d="M17.6 3.6c-2.7-3.8-8-4.8-11.9-2-3.9 2.8-4.8 8.1-2 12 2.4 3.5 6.9 4.6 10.6 2.9l4.9 6.9c.5.7 1.5.8 2.2.4s.9-1.5.4-2.2l-4.9-6.9c2.7-2.9 3.2-7.6.7-11.1zm-3.2 10.3c-2.9 2.1-6.9 1.4-9-1.6-2.1-2.8-1.4-6.9 1.5-9 2.9-2.1 6.9-1.4 9 1.6 2.1 2.9 1.4 7-1.5 9z" />
  </>
);
